import React, { useEffect } from 'react';
import { Row, Col } from 'antd';

const GoToAdmission = ({ setStep }) => {

   const returnToSearch = () => {
      localStorage.clear();
      setTimeout(() => {
         setStep(1);
      }, 20000);
   };

   useEffect(() => {
      returnToSearch();
   }, []);

   return (
      <Row justify="center" className="mt-120">
         <Col lg={22} md={22} className="go-to-admission-container p-40">
            <Row justify="center">
               <Col lg={22} md={22}>
                  <h1 className="text-center mb-20">¿Hay algún error en los datos?</h1>
                  <h3>Si los datos personales están incorrectos, incompletos o corresponden a otra persona, <strong>dirígete en este momento a recepción para corregirlo.</strong></h3>
                  <p className="text-center mt-30 mb-0">¡Muchas gracias!</p>
               </Col>
            </Row>
         </Col>
      </Row>
   );
};

export default GoToAdmission;